module.exports = __webpack_public_path__ + "img/welfare-ico-2.8ace6871.png";